import type { SmokeTestHistoryResponseDto } from '@terra/shared-contracts-smoke-test-history';

export function mergeAgentExecutionSmokeHistory({
  adapted,
  smokeTestHistory,
}: {
  adapted: SmokeTestHistoryResponseDto;
  smokeTestHistory: SmokeTestHistoryResponseDto | undefined;
}): SmokeTestHistoryResponseDto {
  if (!smokeTestHistory) {
    return adapted;
  }

  return {
    ...adapted,
    signalId: smokeTestHistory.signalId ?? adapted.signalId,
    signal: smokeTestHistory.signal ?? adapted.signal,
    status: smokeTestHistory.status ?? adapted.status,
    metadata: smokeTestHistory.metadata ?? adapted.metadata,
    postAttackMessages:
      smokeTestHistory.postAttackMessages ?? adapted.postAttackMessages,
    postAttackTraceId:
      smokeTestHistory.postAttackTraceId ?? adapted.postAttackTraceId,
  };
}
